export const isNormalLink = (uri: string) => uri.startsWith('http');
